import React, { type PropsWithChildren } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { StyleSheet, View, type ViewStyle } from 'react-native';
import { IconLink, Modal, theme } from '@sg/garnish';

export const LoyaltyPostPurchaseModal = (
  props: LoyaltyPostPurchaseModalProps,
) => {
  const {
    visible,
    children,
    onRequestClose,
    onCloseButtonPress,
    style,
    isPremium = false,
  } = props;

  const { formatMessage } = useIntl();

  return (
    <Modal
      size="medium"
      fitHeight
      visible={visible}
      onRequestClose={onRequestClose}
      accessibilityLabel={formatMessage(messages.modalA11yLabel)}
      presentationStyle="pageSheet"
      palette={isPremium ? 'dark-kale' : 'forest'}
    >
      <View style={[styles.innerContainer, style]}>
        <IconLink
          name="IconClose"
          palette="light-semi-transparent"
          width={40}
          height={40}
          accessibilityLabel={formatMessage(messages.closeA11yLabel)}
          onPress={onCloseButtonPress}
          style={styles.closeButton}
        />
        {children}
      </View>
    </Modal>
  );
};

// ─── Messages ────────────────────────────────────────────────────────────────

const messages = defineMessages({
  modalA11yLabel: {
    defaultMessage: 'Loyalty offers modal',
    description: 'Loyalty Post Purchase | Modal | a11y label',
  },
  closeA11yLabel: {
    defaultMessage: 'Close modal',
    description: 'Loyalty Post Purchase | Modal | Close button a11y label',
  },
});

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  innerContainer: {
    flexDirection: 'row',
    flexShrink: 0,
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing['4'],
    right: theme.spacing['4'],
    zIndex: 1,
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LoyaltyPostPurchaseModalProps = PropsWithChildren<{
  visible: boolean;
  onCloseButtonPress: () => void;
  onRequestClose: () => void;
  style?: ViewStyle;
  isPremium?: boolean;
}>;
